import React, { useState } from 'react'

import PropTypes from 'prop-types'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'

import { CreateNewField, SelectExistingField } from './components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'

import useStyles from './styles'

const FragilityFields = ({
  linkedFragilities,
  stagedFragilities,
  setStagedFragilities,
  saving,
}) => {
  const [mode, setMode] = useState('select')

  const classes = useStyles()

  const { response, isLoading } = useFetch(
    service.dponet.companyFragilities.get,
    {
      status: constants.fragilities.ACTIVE,
      perPage: 1000,
      order: ['name ASC'],
      minimal: true,
    },
    [],
  )

  const companyFragilities = response?.data?.companyFragilities ?? []

  const handleStage = (fragility) =>
    setStagedFragilities((current) => [...current, fragility])

  const handleChangeMode = (_, value) => {
    if (!value) return
    setMode(value)
  }

  return (
    <>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={mode}
        onChange={handleChangeMode}
        className={classes.toggleGroup}
      >
        <ToggleButton
          value="select"
          disabled={saving}
          className={classes.toggleButton}
        >
          Selecionar existente
        </ToggleButton>
        <ToggleButton
          value="create"
          disabled={saving}
          className={classes.toggleButton}
        >
          Criar nova
        </ToggleButton>
      </ToggleButtonGroup>

      {mode === 'select' ? (
        <SelectExistingField
          companyFragilities={companyFragilities}
          isLoading={isLoading}
          linkedFragilities={linkedFragilities}
          stagedFragilities={stagedFragilities}
          onStage={handleStage}
          saving={saving}
        />
      ) : (
        <CreateNewField
          companyFragilities={companyFragilities}
          stagedFragilities={stagedFragilities}
          onStage={handleStage}
          saving={saving}
        />
      )}
    </>
  )
}

FragilityFields.propTypes = {
  linkedFragilities: PropTypes.array,
  stagedFragilities: PropTypes.array,
  setStagedFragilities: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

export default FragilityFields
